import React, { FC, useContext, useEffect, useState } from 'react'

import { Button } from '../../../../../components/ui/button'
import { Input } from '../../../../../components/ui/input'

import { getFloatPrice } from '../../../../../helpers/price'
import { cn } from '../../../../../lib/utils'

import { HandleModalContext } from '../../../../../layout/mainlayout/MainLayout'

import useRegistrationFees from '../../../../../hooks/useRegistrationFees'

import { useAppSelector } from '../../../../../store/hooks'
import { selectRegistrationFeesR } from '../../../../../store/registration/registrationSlice'
import { selectedEvent } from '../../../../../store/events/eventsSlice'

import { IFeesTab } from '../../../../../models/event-registered-users/event-registered-users.interface'

import { FEES_CATEGORY_CONST } from '../../../../../components/events/views/details/EventDetailsViewComponentFees'
import { MODAL_CONSTS } from '../../../../../const/modal-const'

interface FeesRowProps {
  item: IFeesTab
  loading: boolean
  setLoading: (state: boolean) => void
  currency: string
  available: number
}

export const FeesRow: FC<FeesRowProps> = ({ item, loading, setLoading, currency, available }) => {
  const handleModal = useContext(HandleModalContext)?.handleModal
  const registrationFees = useAppSelector(selectRegistrationFeesR)
  const selectedEventR = useAppSelector(selectedEvent)

  const { onChangeFees } = useRegistrationFees()

  const [inputValue, setInputValue] = useState<string | number>('')

  const openSeeMoreModal = (content: string) => {
    handleModal?.(true, MODAL_CONSTS.ADD_NOTE, { noteInputRef: content })
  }

  useEffect(() => {
    const count = registrationFees.filter((fee) => fee.feesItemId === item.feesItemId)
    setInputValue(count?.[0] ? count.length : '')
  }, [item.feesItemId, registrationFees])

  return (
    <div className="flex flex-wrap items-center justify-between w-full gap-2 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-b-black/10 pt-4 [&:not(:last-child)]:pb-4">
      <div className="w-full sm:max-w-[50%]">
        <h6 className="text-sm font-normal"> {item?.feesTitle || 'No title'}</h6>
        <div className="flex flex-wrap items-center gap-1 text-xs text-black/50 mt-1">
          <p>{getFloatPrice(`${currency}${item.feesPrice}`)}</p>
          <span>•</span>
          {item?.feesDuration && item?.feesDuration !== 'N/A' && (
            <>
              <p className="capitalize">{item?.feesDuration}</p>
              <span>•</span>
            </>
          )}
          {!isNaN(Number(available)) && item.feesCategory !== FEES_CATEGORY_CONST.GOVERNANCE && (
            <p>
              {available} remaining <span>•</span>
            </p>
          )}
          <Button
            variant="underline"
            className="text-xs text-black/50 p-0 bg-transparent"
            onClick={() => openSeeMoreModal(item.feesDescription || 'No description')}
          >
            More
          </Button>
        </div>
      </div>

      <Input
        type="number"
        name="available"
        disabled={item.feesCategory === FEES_CATEGORY_CONST.GOVERNANCE || loading || available <= 0}
        onChange={(e) => {
          const value = e.target.value
          if (Number(value) > Number(available)) setInputValue(available)
          else setInputValue(value)
        }}
        onKeyDown={(e) => {
          if (e.key === '.' || e.key === ',' || e.key === 'e') e.preventDefault()
        }}
        className={cn(
          'w-full sm:w-[160px] text-center p-3 h-auto',
          inputValue > 0 && 'bg-SeabiscuitGrayThemeColor border-SeabiscuitGrayThemeColor'
        )}
        placeholder={available <= 0 ? 'No available' : 'Enter units'}
        value={
          item.feesCategory === FEES_CATEGORY_CONST.GOVERNANCE
            ? item.registrationFees?.selectedUnitsCount || 0
            : inputValue
        }
        onBlur={async () => {
          setLoading(true)
          await onChangeFees({
            currentRow: item,
            selectedCount: Number(inputValue),
            publishedEvent: selectedEventR,
          })
          setLoading(false)
        }}
      />
    </div>
  )
}
